import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/axios';

const storedUser = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;
const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (!user?.token) {
    throw new Error('Authentication token is missing or invalid');
  }
  return {
    Authorization: `Bearer ${user.token}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
};

export const DoWalletTopUp = createAsyncThunk(
  'wallet/top-up',
  async ({ WalletopUp }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(
        `/wallet/top-up`,
        WalletopUp,
        { headers: getAuthHeaders() }
      );

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to proceed top up',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const MakePayments = createAsyncThunk(
  'flight/group-make-payment',
  async ({ postData }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(
        `/flight/v3/group-make-payment`,
        postData,
        { headers: getAuthHeaders() }
      );

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to proceed top up',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const DoBNPLCredit = createAsyncThunk(
  'bnpl/credit',
  async ({ BNPDue }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(
        `/bnpl/credit`,
        BNPDue,
        { headers: getAuthHeaders() }
      );

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to proceed top up',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const fetchWalletbalance = createAsyncThunk(
  'wallet/balance',
  async ({ balanceReq }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/wallet/balance`,
        balanceReq,
        { headers: getAuthHeaders() }
      );

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to proceed balance',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const verifyifsc = createAsyncThunk(
  'wallet/verify-ifsc',
  async ({ Payload }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/finance/verify-ifsc`,
        Payload,
        { headers: getAuthHeaders() }
      );

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to proceed balance',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
// export const DoDepositRequest = createAsyncThunk(
//   'wallet/deposit-request',
//   async (payload, { rejectWithValue }) => {
//     try {
//       const response = await api.post(
//         `/wallet/deposit-request`,
//         payload,
//         { headers: getAuthHeaders() }
//       );

//       return { data: response.data };
//     } catch (error) {
//       return rejectWithValue({
//         message: error.message || 'Failed to proceed balance',
//         status: error.response?.status,
//         data: error.response?.data,
//       });
//     }
//   }
// );

export const DoDepositRequest = createAsyncThunk("wallet/deposit-request", async (payload, { rejectWithValue }) => {
  try {
    const response = await api.post(`/wallet/deposit-request`, payload, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data", // Important for file upload
      },
    });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const DoWithdrawalRequest = createAsyncThunk("wallet/withdrawal-request", async (payload, { rejectWithValue }) => {
  try {
    const response = await api.post(`/wallet/withdrawal-request`, payload, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data", // Important for file upload
      },
    });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const fetchwallethistory = createAsyncThunk(
  'wallet/history',
  async ({ FilterData, perPage, currentPage }, { rejectWithValue }) => {
    try {
      let url = `/wallet/history?per_page=${perPage}&page=${currentPage}`;
      // API call to validate fare
      const response = await api.post(
        url,
        FilterData,
        { headers: getAuthHeaders() }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to validate data',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const fetchfranchisehistory = createAsyncThunk(
  'wallet/franchise',
  async ({ FilterData, perPage, currentPage }, { rejectWithValue }) => {
    try {
      let url = `/wallet/franchise?per_page=${perPage}&page=${currentPage}`;
      // API call to validate fare
      const response = await api.post(
        url,
        { customer_id: FilterData.customer_id, filterData: FilterData },
        { headers: getAuthHeaders() }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to validate data',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const fetchdepositrequest = createAsyncThunk(
  'wallet/deposit-request-list',
  async ({ FilterData, perPage, currentPage }, { rejectWithValue }) => {
    try {
      let url = `/wallet/deposit-request-list?per_page=${perPage}&page=${currentPage}`;
      // API call to validate fare
      const response = await api.post(
        url,
        FilterData,
        { headers: getAuthHeaders() }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to validate fare',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const fetchbankList = createAsyncThunk(
  'wallet/bank-accounts',
  async ({ FilterData }, { rejectWithValue }) => {
    try {
      let url = `/bank-accounts`;
      // API call to validate fare
      const response = await api.post(
        url,
        FilterData,
        { headers: getAuthHeaders() }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to validate fare',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const fetchwithdrawalrequest = createAsyncThunk(
  'wallet/withdrawal-request-list',
  async ({ FilterData, perPage, currentPage }, { rejectWithValue }) => {
    try {
      let url = `/wallet/withdrawal-request-list?per_page=${perPage}&page=${currentPage}`;
      // API call to validate fare
      const response = await api.post(
        url,
        FilterData,
        { headers: getAuthHeaders() }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to validate fare',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);


const walletsSlice = createSlice({
  name: 'wallet',
  initialState: {
    loading: false,
    error: null,
    walletpaymentInitiated: false,
    walletpaymentStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    walletbalanceStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    walletbnplStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    wallethistoryStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    franchisehistoryStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    depositrequestStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    withdrawalStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    depositStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    MakePaymentStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    wallettransactionId: null,
    walletpaymentData: null,
    walletbalanceData: null,
    walletbnplData: null,
    wallethistory: null,
    franchisehistory: null,
    depositrequestData: null,
    withdrawalrequestData: null,
    depositData: null,
    MakePaymentData: [],
    user: storedUser,
  },
  reducers: {
    clearWalletError: (state) => {
      state.error = null;
    },
    clearBNPLError: (state) => {
      state.error = null;
      state.walletbnplStatus = 'idle';
      state.walletbnplData = null;
    },
    clearDepositError: (state) => {
      state.error = null;
      state.depositStatus = 'idle';
      state.depositData = null;
    },
    resetWalletPayment: (state) => {
      state.loading = false;
      state.error = null;
      state.walletpaymentInitiated = false;
      state.walletpaymentStatus = 'idle';
      state.wallettransactionId = null;
      state.walletpaymentData = null;
    },
    setWalletPaymentStatus: (state, action) => {
      state.walletpaymentStatus = action.payload.status.success;
      // state.wallettransactionId = action.payload.transaction_id;
    },
    WalletToupResponse: (state, action) => {
      const response = action.payload;
      console.log('wallet response received:', response);

      // if (response.txnid) {
      //   state.wallettransactionId = response.txnid;
      //   state.walletpaymentStatus = response.status === 'success' ? 'success' : 'failed';
      // }
    }
  },
  extraReducers: (builder) => {
    builder
      // Initiate Easebuzz Payment
      .addCase(DoWalletTopUp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.walletpaymentInitiated = false;
      })
      .addCase(DoWalletTopUp.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.walletpaymentInitiated = true;
        state.walletpaymentStatus = data.status.success;
        state.walletpaymentData = data || {};
      })
      .addCase(DoWalletTopUp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.walletpaymentInitiated = false;
        state.walletpaymentStatus = 'failed';
      }).addCase(fetchWalletbalance.pending, (state) => {
        state.walletbalanceStatus = 'loading';
      })
      .addCase(fetchWalletbalance.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.walletbalanceStatus = data.status.success;
        state.walletbalanceData = data || {};
      }).addCase(DoBNPLCredit.pending, (state) => {
        state.walletbnplStatus = 'loading';
      })
      .addCase(DoBNPLCredit.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.walletbnplStatus = data.status.success;
        state.walletbnplData = data || {};
      }).addCase(fetchwallethistory.pending, (state) => {
        state.wallethistoryStatus = 'loading';
      }).addCase(fetchwallethistory.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.wallethistoryStatus = data.status.success;
        state.wallethistory = data || {};
      }).addCase(fetchfranchisehistory.pending, (state) => {
        state.franchisehistoryStatus = 'loading';
      }).addCase(fetchfranchisehistory.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.franchisehistoryStatus = data.status.success;
        state.franchisehistory = data || {};
      }).addCase(fetchdepositrequest.pending, (state) => {
        state.depositrequestStatus = 'loading';
      }).addCase(fetchdepositrequest.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.depositrequestStatus = data.status.success;
        state.depositrequestData = data || {};
      })
      .addCase(fetchwithdrawalrequest.pending, (state) => {
        state.withdrawalStatus = 'loading';
      }).addCase(fetchwithdrawalrequest.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.withdrawalStatus = data.status.success;
        state.withdrawalrequestData = data || {};
      })
      .addCase(DoDepositRequest.pending, (state) => {
        state.depositStatus = 'loading';
      }).addCase(DoDepositRequest.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.depositStatus = data.status.success;
        state.depositData = data || {};
      }).addCase(MakePayments.pending, (state) => {
        state.MakePaymentStatus = 'loading';
      }).addCase(MakePayments.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.MakePaymentStatus = data.status.success;
        state.MakePaymentData = data || {};
      });
  },
});


export const {
  clearWalletError,
  clearBNPLError,
  clearDepositError,
  resetWalletPayment,
  setWalletPaymentStatus,
  WalletToupResponse
} = walletsSlice.actions;

export const selectwalletpaymentData = (state) => state.wallet.walletpaymentData;
export default walletsSlice.reducer;